import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import TablePagination from "react-js-pagination";

//useStyle

const Pagination = (props) => {
  const {
    totalItem,
    activePage,
    pageSize,
    onActivePageChange,
    onPageSizeChange,
  } = props;

  const handlePageChange = (pageNumber) => {
    onActivePageChange(pageNumber);
  };

  const handlePageSizeChange = (event) => {
    onPageSizeChange(event.target.value);
  };

  const totalPages = Math.ceil(totalItem / pageSize);
  const minPageSize = 10;

  return (
    (totalItem > minPageSize || totalItem > pageSize) && (
      <div className=" row gx-0 custom-pagination m-0 p-3">
        <div className="col-12 pagination d-flex gap-4">
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="per-page" style={{ fontSize: 14 }}>
              Page Size
            </InputLabel>
            <Select
              labelId="per-page"
              label="Page Size"
              className="rounded page-size-select"
              value={pageSize}
              onChange={handlePageSizeChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={30}>30</MenuItem>
            </Select>
          </FormControl>

          <div>
            <p
              style={{
                marginBottom: "0px",
                color: "1F1F1F",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Showing {activePage} out of {totalPages} pages
            </p>
            <TablePagination
              activePage={activePage}
              itemsCountPerPage={pageSize}
              totalItemsCount={totalItem}
              pageRangeDisplayed={3}
              onChange={(page) => handlePageChange(page)}
              itemClass="page-item"
            />
          </div>
        </div>
      </div>
    )
  );
};
export default Pagination;
